@charset "UTF-8";

/* src/app/components/controls/sem-query-builder/query-builder.component.scss */
:host {
  display: block;
  width: 95%;
  margin-bottom: 10px;
}
:host .q-icon {
  font-style: normal;
  font-size: 12px;
}
:host .q-remove-icon::before {
  content: "\274c";
}
:host .q-arrow-icon-button {
  float: left;
  margin: 4px 6px 4px 0;
  transform: rotate(90deg);
  transition: linear 0.25s transform;
  cursor: pointer;
}
:host .q-arrow-icon-button.q-collapsed {
  transform: rotate(0);
}
:host .q-arrow-icon::before {
  content: "\25b6";
}
:host .q-add-icon {
  color: #555;
}
:host .q-remove-button {
  color: #B3415D;
  width: 31px;
}
:host .q-switch-group,
:host .q-button-group {
  font-family:
    "Lucida Grande",
    Tahoma,
    Verdana,
    sans-serif;
  overflow: hidden;
  padding-top: 10px;
  padding-bottom: 10px;
}
:host .q-switch-group {
  padding-left: 20px;
}
:host .q-button-group {
  padding-right: 20px;
}
:host .q-right-align {
  float: right;
}
:host .q-button {
  margin-left: 8px;
  padding: 0 8px;
  background-color: white;
}
:host .q-button:disabled {
  display: none;
}
:host .q-control-size {
  display: inline-block;
  vertical-align: top;
  padding-right: 10px;
}
:host .q-input-control,
:host .q-operator-control,
:host .q-field-control,
:host .q-entity-control {
  display: inline-block;
  padding: 5px 8px;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  width: auto;
}
:host .q-input-control:disabled,
:host .q-operator-control:disabled,
:host .q-field-control:disabled,
:host .q-entity-control:disabled {
  border-color: transparent;
}
:host .q-operator-control,
:host .q-field-control,
:host .q-entity-control,
:host .q-input-control:not([type=checkbox]) {
  min-height: 32px;
  -webkit-appearance: none;
}
:host .q-switch-label,
:host .q-button {
  float: left;
  margin-bottom: 0;
  font-size: 8px;
  line-height: 21px;
  font-weight: normal;
  text-align: center;
  text-shadow: none;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  font-family: "robotoregular";
}
:host .q-switch-label:hover,
:host .q-button:hover {
  cursor: pointer;
  background-color: #F0F0F0;
}
:host .q-button {
  font-weight: 600 !important;
  text-transform: uppercase;
  font-stretch: normal;
  font-style: normal;
  line-height: normal !important;
  letter-spacing: normal !important;
  color: #282828 !important;
  border-radius: 3px !important;
  border: solid 1px #e5eaed !important;
  padding-bottom: 2px;
}
:host .q-switch-label {
  background-color: #e5eaed;
  padding: 0 8px;
  height: 21px;
  color: #81898c;
}
:host .q-switch-label-and {
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}
:host .q-switch-label-or {
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px;
}
:host .q-switch-radio {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  width: 1px;
  border: 0;
  overflow: hidden;
}
:host .q-switch-radio:checked + .q-switch-label {
  border: 1px solid rgb(97, 158, 215);
  background: #1873b1 !important;
  color: #ffffff;
}
:host .q-switch-radio:disabled + .q-switch-label {
  display: none;
}
:host .q-switch-radio:checked:disabled + .q-switch-label {
  display: initial;
  color: initial;
  cursor: default;
  border-color: transparent;
}
:host .q-invalid-ruleset {
  border: 1px solid rgba(179, 65, 93, 0.5) !important;
  background: rgba(179, 65, 93, 0.1) !important;
}
:host .q-empty-warning {
  color: rgb(141, 37, 46);
  text-align: center;
}
:host .q-ruleset {
  border: 1px solid #CCC;
}
:host .q-rule {
  border: 1px solid #CCC;
  background: white;
}
:host .q-transition {
  -webkit-transition: all 0.1s ease-in-out;
  -moz-transition: all 0.1s ease-in-out;
  -ms-transition: all 0.1s ease-in-out;
  -o-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
}
:host .q-tree-container {
  width: 100%;
  transition: ease-in 0.25s max-height;
}
:host .q-tree-container.q-collapsed {
  max-height: 0 !important;
}
:host .q-tree {
  list-style: none;
  margin: 4px 0 2px;
}
:host .q-row {
  padding: 6px 8px;
  margin-top: 6px;
  border-radius: 3px;
  border: solid 1px #e5eaed;
  width: 90%;
  margin-left: 5%;
  margin-bottom: 10px;
}
:host .q-connector {
  position: relative;
}
:host .q-connector::before {
  top: -5px;
  border-width: 0 0 2px 2px;
}
:host .q-connector::after {
  border-width: 0 0 0 2px;
  top: 50%;
}
:host .q-connector::before,
:host .q-connector::after {
  content: "";
  left: -12px;
  border-color: #CCC;
  border-style: solid;
  width: 9px;
  height: calc(50% + 6px);
  position: absolute;
}
:host .q-connector:last-child::after {
  content: none;
}
:host .q-inline-block-display {
  display: inline-block;
  vertical-align: top;
}
/*# sourceMappingURL=query-builder.component.css.map */
